import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-chatbox',
  templateUrl: './chatbox.component.html',
  styleUrls: ['./chatbox.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ChatboxComponent implements OnInit {
  chatboxStatus: boolean = false;
  constructor() { }

  ngOnInit() {
  }

  openChatBox(){
    this.chatboxStatus = true;
  }

  closeChatBox(){
    this.chatboxStatus = false;
  }

}